import React from 'react';
import { Typography, Grid } from '@mui/material';
import SectionCollapse from '../../../../section/SectionCollapse';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateClassPreview } from '../../../../../store/actions/class.actions';
import CardUnitOfLearning from '../CardUnitOfLearning/CardUnitOfLearning';

const UnitOfLearnings = ({ items = [] }) => {
  const { studentId } = useParams();
  const dispatch = useDispatch();
  const formData = useSelector((state) => state?.class?.form || {});
  const curriculumId = formData.curriculumId;
  const classId = formData._id;
  const redirectStudentId = studentId ? `${studentId}/` : '';

  const onClose = () => {
    dispatch(updateClassPreview(null));
  }

  return (
    <SectionCollapse title={`Units of learning (#${items?.length})`}>
      {items.length > 0 ? (
        <Grid container alignItems='center' spacing={1}>
          {items.map((item, index) => (
            <Grid item xs={12} lg={12 / 5} md={12 / 4} sm={12 / 3} key={`${item._id}-${index}`}>
              {classId ? (
                <Link
                  button
                  to={`/dashboard/${redirectStudentId}classes/${curriculumId}/preview/${classId}/unit-of-learning/${item._id}`}
                >
                  <CardUnitOfLearning
                    key={`${item._id}-${index}`}
                    item={item}
                    onClick={onClose}
                  />
                </Link>
              ) : (
                <CardUnitOfLearning
                  key={`${item._id}-${index}`}
                  item={item}
                  onClick={onClose}
                />
              )}
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography className='text-muted-foreground opacity-50'>
          You don't have any units of learning yet
        </Typography>
      )}
    </SectionCollapse>
  );
};

export default UnitOfLearnings;
